/* eslint-disable import/prefer-default-export */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStringifiedQueryParams } from 'utils/helpers/fetch';

const oidcStorage = JSON.parse(
  sessionStorage.getItem(
    `oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
  )
);
const auth = `Bearer ${oidcStorage?.access_token}`;

const timsApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ODS_BASE_URL}/`,
    paramsSerializer: getStringifiedQueryParams,
    prepareHeaders: headers => {
      if (oidcStorage) headers.set('authorization', auth);
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: 'timsApi',
  tagTypes: [],
});

export default timsApi;
